import React, { useState } from "react";

import Slider from "react-slick";

const NextArrow = props => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        right: "155px",
        width: "40px",
        height: "45px",
      }}
      onClick={onClick}>
      <img src='/assets/images/white/next.svg' alt='Next' width='40' />
    </div>
  );
};

const PrevArrow = props => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        left: "135px",
        width: "40px",
        height: "45px",
        zIndex: "10",
      }}
      onClick={onClick}>
      <img src='/assets/images/white/prev.svg' alt='Prev' width='40' />
    </div>
  );
};

function HomeSlider({t,language}) {
  var settings = {
    dots: true,
    className: "center",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "10%",
    // autoplay: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768, // Adjust for smaller screens
        settings: {
          slidesToShow: 1, // Show 1 slide on smaller screens
          centerPadding: "100px",
        },
      },
    ],
  };

  const [slider, setSlider] = useState([
    {
      title_en: "Discover all Egyptian products with international export quality",
      desc_en: "We manufacture and export a variety of products in various industries with high quality to all parts of the world",
      title_ar: "اكتشف جميع المنتجات المصرية بجودة تصديرية عالمية",
      desc_ar: "نحن نصنع ونصدر مجموعة متنوعة من المنتجات في مختلف الصناعات بجودة عالية إلى جميع أنحاء العالم",
      image_path: "sp_1.svg",
    },
    {
      title_en: "Providing Best and Most Secure Transportation Services",
      desc_en: "We have great experience of providing the latest methods of exporting them and competing in the world markets",
      title_ar: "نوفر أفضل خدمات النقل وأكثرها أمانًا",
      desc_ar: "لدينا خبرة كبيرة في توفير أحدث طرق التصدير والمنافسة في الأسواق العالمية",
      image_path: "sp_2.svg",
    },
    {
      title_en: "Make your Trading Business more unique with Our Products",
      desc_en: "We offer a comprehensive variety of products to streamline your exporting & trading operations",
      title_ar: "اجعل عملك التجاري أكثر تميزًا بمنتجاتنا",
      desc_ar: "نقدم تشكيلة شاملة من المنتجات لتبسيط عمليات التصدير والتجارة الخاصة بك",
      image_path: "sp_3.svg",
    },
  ]);

  return (
    <Slider {...settings}>
      {slider.map((item, index) => (
        <div className='side' key={index}>
          <div className='container h-100'>
            <div className='row align-items-center h-100'>
              <div className='col-md-7'>
                <div className='slide_title'>{language==='ar' ? item.title_ar : item.title_en}</div>
                <div className='slide_desc'>{language==='ar' ? item.desc_ar : item.desc_en}</div>
                <a href='/shop' className='slide_shop_btn'>{t('shop_now')} &gt;&gt;</a>
              </div>
              <div className='col-md-5'>
                <img
                  src={`/assets/images/white/${item.image_path}`}
                  alt='Slider'
                  className='img-fluid'
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </Slider>
    //   <div>{/* <img src="/assets/images/white/slider3.svg" alt="" /> */}</div>
  );
}

export default HomeSlider;
